import * as React from "react";
import { HFCHiddenSearchDataProps } from "../typings";

export const HFCHiddenSearchData = (props: HFCHiddenSearchDataProps) => {
  return (
    <input
      type="hidden"
      name="packageType"
      data-testid="package-type"
      value={props.hotelWizardState.hotelPackageType}
    />
  );
};
